export default "__VITE_ASSET__DfIih6Ga__"